/**
 * Convert BFF endpoint pattern to MSW pattern
 * Converts {param} to :param for MSW compatibility
 *
 * @param endpoint - BFF endpoint pattern with {param} syntax
 * @returns MSW-compatible pattern with :param syntax
 *
 * @example
 * toMSWPattern('subscriptions/{subscriptionId}/bookings')
 * // Returns: 'subscriptions/:subscriptionId/bookings'
 *
 * @example
 * toMSWPattern('users/{userId}/posts/{postId}')
 * // Returns: 'users/:userId/posts/:postId'
 */
export function toMSWPattern(endpoint: string): string {
  return endpoint.replace(/\{(\w+)\}/g, ':$1');
}
